import type { LeDataChatMessage, LeDataContentBlock } from '~/types/leData';

export function isThoughtProcessBlock(block: LeDataContentBlock): boolean {
  return block.type === 'text' && block.payload.section === 'thought-process';
}

export function isCollapsibleResultBlock(block: LeDataContentBlock): boolean {
  return block.type === 'sql' || block.type === 'table';
}

export function isThoughtProcessMessage(message: LeDataChatMessage): boolean {
  return (
    message.role === 'assistant' &&
    !message.text &&
    !message.progress &&
    Array.isArray(message.blocks) &&
    message.blocks.length > 0 &&
    message.blocks.every(isThoughtProcessBlock)
  );
}

export function isCollapsibleResultMessage(message: LeDataChatMessage): boolean {
  return (
    message.role === 'assistant' &&
    !message.text &&
    !message.progress &&
    Array.isArray(message.blocks) &&
    message.blocks.length > 0 &&
    message.blocks.every(isCollapsibleResultBlock)
  );
}
